import script from "./Unpaid.vue?vue&type=script&lang=ts&setup=true"
export * from "./Unpaid.vue?vue&type=script&lang=ts&setup=true"

import "./Unpaid.vue?vue&type=style&index=0&id=49d2e22e&scoped=true&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d2e22e"]])

export default __exports__